class productSave {
// import { string } from 'yup';
    // debugger;
    ProductItemID_GUID: string;
    ProductCategoryID_GUID: string;
    IsAccesory: Boolean;
    Name: string;
    Description:string;
    innerObj: any;
  
    productSave() {
      // debugger;
      this.ProductItemID_GUID = "";
      this.ProductCategoryID_GUID = "";
      this.IsAccesory = false;
      this.Name = "";
      this.Description = "";
    }
  }
  
  export default productSave;
  